import React from 'react'
import { Common } from './index'

export default (setCommon: React.Dispatch<React.SetStateAction<Common>>) => {

  return {  }
}
